export default __webpack_public_path__ + "static/media/ethics.92fd4164.jpg";